import React, { useState } from "react";
//import validation lib
import validator from "validator";

//importing Assets
import Logo from "../Assets/logos/logo.svg";
import LoginPic from "../Assets/illustration/login.svg";
import InputField from "../components/inputs/inputField";
import { Link, useNavigate } from "react-router-dom";
import InputCheckBox from "../components/inputs/inputCheckbox";
import InputPassword from "../components/inputs/inputPassword";
import { Spinner1 } from "../components/spinners/Spinner1";
import { useDispatch, useSelector } from "react-redux";
import { loginAction } from "../store/auth";
import { useEffect } from "react";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState({
    email: "",
    password: "",
  });
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    if (auth.success) {
      navigate("/dashboard");
      localStorage.setItem("jwt", auth.user);
    }
  }, [auth]);

  const handleChange = ({ target }) => {
    setValues({ ...values, [target.name]: target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    //valid email and password
    let valid = true;
    if (values.password.length < 8) {
      valid = false;
      console.log(error);

      setError({
        ...error,
        password: "يجب ان لا تقل علي 8 حروف",
      });
    } else {
      setError({
        ...error,
        password: "",
      });
    }
    if (!validator.isEmail(values.email) || values.email === "") {
      console.log(error);
      valid = false;
      setError({
        ...error,
        email: "غير صحيح",
      });
    } else {
      setError({
        ...error,
        email: "",
      });
    }

    if (valid) {
      dispatch(loginAction(values));
    }
  };
  return (
    <div className="login">
      {auth.loading && <Spinner1 />}
      <form className="login__form" onSubmit={handleSubmit}>
        <div className="login__form__content">
          <img src={Logo} alt="logo" className="login__logo" />
          <h2 className="ternary__heading ternary__heading--dark">
            قم بتسجيل الدخول الي حسابك
          </h2>
          <p className="ternary__heading ternary__heading--light">
            مرحبًا مرة أخرى ، أدخل تفاصيل تسجيل الدخول الخاصة بك.{" "}
          </p>
          <InputField
            onChange={handleChange}
            error={error.email}
            name="email"
            title="البريد الالكتروني"
            placeholder="ادخل البريد الالكتروني"
            required={true}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
          />
          <InputPassword
            required={true}
            onChange={handleChange}
            name="password"
            error={error.password}
            title="كلمة المرور"
            placeholder="ادخل كلمة المرور"
          />
          <div
            className="flex-between full-width"
            style={{ flexDirection: "row" }}
          >
            <InputCheckBox item title="تذكرني" />

            <div className="input__box ">
              <Link to="/forget-password" className="input__forget-pass">
                هل نسيت كلمة المرور ؟
              </Link>
            </div>
          </div>
          <div className="input__box">
            <button className="btn btn__primary btn__full">تسجيل الدخول</button>
          </div>
        </div>
      </form>
      <div className="login__image-box">
        <img src={LoginPic} alt="login " className="login__image" />
      </div>
    </div>
  );
};

export default Login;
